import { gql } from '@apollo/client';

export default gql`
  mutation processBusinessAccountPrrRefund(
    $bookingReference: String!
    $refundAmount: Float!
    $currency: Currency!
    $account: String!
    $additionalDetails: [InputAdditionalDetails!]!
    $compensationRecordsToUpdate: [InputCompensationRecordToUpdate]
  ) {
    processBusinessAccountPrrRefund(
      bookingReference: $bookingReference
      refundAmount: $refundAmount
      currency: $currency
      account: $account
      additionalDetails: $additionalDetails
      compensationRecordsToUpdate: $compensationRecordsToUpdate
    ) {
      bookingReference
      updatedCompensationRecords
    }
  }
`;
